import { NotificationType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const notificationTypeDictionary = createSimpleDictionary([
    { id: NotificationType.Info, name: 'notifications.types.info' },
    { id: NotificationType.Warning, name: 'notifications.types.warning' },
    { id: NotificationType.Error, name: 'notifications.types.error' },
    { id: NotificationType.Message, name: 'notifications.types.message' },
]);
